export const PAGE_SIZE = 50;
export const DEBOUNCE_MS = 400;
export const NO_DATA_MESSAGES = {
  empty: {
    headline: 'No blocked players yet',
    text: 'Currently there are no blocked users for your store',
  },
  noResults: {
    headline: 'No exact matches',
    text: 'Try changing or removing some of your filters or adjusting your search area',
  },
} as const;
